import api from "./api";

export type Type = {
  id: number;
  rate: number;
  timestamp:string
};
export const getCurencyRate = async () => {
  return await api.get("/currencies/rates");
};

export const getCurencyRateApi = async (body: { limit: number }) => {
  let url = `/currencies/rates?limit=${body.limit}`;
  return await api.get(url);
};

export const getSingleCurencyRate = async (id: any) => {
  return await api.get(`/currencies/${id}/rates`);
};

export const createExchangeRate = async (
  exchangeDetails: Type,
  currencyId: number
) => {
  const { rate, ...rest } = exchangeDetails;
  const updatedExchangeDetails = { ...rest, rate: Number(rate) };
  return await api.post(
    `/currencies/${currencyId}/rates`,
    updatedExchangeDetails
  );
};
